import React, { ReactElement } from 'react';
import { Paragraph } from '@trainline/depot-web';
import { css } from 'aphrodite/no-important';

import FormattedCurrency from '@contactcentre-web/common/FormattedCurrency';

import styles from './styles';

interface FareWrapperProps {
  uri?: string;
  fareSearchUrl?: string;
  alternativeIds: string[];
  type: string;
  upgradedAfterCharge: boolean;
  children: ReactElement;
}

// probably need this from BE
enum TicketType {
  single = 'Single',
  maxFare = 'Max Fare',
  return = 'Return',
  undeterminedJourney = 'Undetermined',
  season = 'Season',
}
type TicketTypeKey = keyof typeof TicketType;

export const FareWrapper = (props: FareWrapperProps) => (
  <div key={props.uri} className={css(styles.wrapper)}>
    <div className={css(styles.header)}>
      <Paragraph fontWeight="semibold" typeStyle="body">
        {TicketType[props.type as TicketTypeKey] ?? props.type}
      </Paragraph>
      <Paragraph fontWeight="semibold" typeStyle="body">
        <FormattedCurrency currency="GBP" amount={7.1} />
      </Paragraph>
    </div>
    <div style={{ marginTop: 0, borderRadius: 0 }}>{props.children}</div>
  </div>
);
